import React, { FunctionComponent } from 'react';
import ScrollToWrapper from '../../../presentational/ScrollToWrapper';
import FeatureSection from './FeatureSection';
import ISection from '../../../../model/ISection';
import { Box } from '@material-ui/core';
import featureSectionContainerStyles from './featureSectionContainerStyles';
export interface ICustomiseSectionsContainerProps {
  sections: ISection[];
  loading: boolean;
}

const FeatureSectionsContainer: FunctionComponent<ICustomiseSectionsContainerProps> = ({ sections, loading }) => {
  const styles = featureSectionContainerStyles();

  return (
    <>
      {sections?.map((section, value) => (
        <Box pb={6} key={value} className={styles.container}>
          <ScrollToWrapper target={section.code}>
            <FeatureSection section={section} loading={loading} />
          </ScrollToWrapper>
        </Box>
      ))}
    </>
  );
};

export default FeatureSectionsContainer;
